// pt-BR of the micro-system flow; complete for every key of en-microsystem.ts (checked by the type).
import type { enMicrosystem } from "./en-microsystem.ts";

export const ptBRMicrosystem: Record<keyof typeof enMicrosystem, string> = {
  "launch.title": "Lançamento",
  "launch.opensInNewTab": "(abre em uma nova aba)",
  "launch.repository": "Repositório",
  "launch.queued": "Na fila",
  "launch.ready": "Pronto",
  "launch.failed": "Falhou",
  "launch.planning": "Planejamento",
  "launch.planningNone": "Ainda não planejado",
  "launch.agents": "Agentes",
  "launch.agentsNotStarted": "Não iniciados",
  "launch.agentsRunning": "Trabalhando",
  "launch.agentsWaiting": "Aguardando recursos",
  "launch.executionEnabled": "Execução do projeto habilitada. A atividade do agente aparece quando uma tentativa começa.",
  "launch.agentsPaused": "Pausados",
  "launch.agentsDone": "Todas as tarefas concluídas",
  "launch.startAgents": "Iniciar agentes",
  "launch.startHint": "Os agentes constroem as tarefas planejadas em paralelo; cada uma é testada e integrada na main.",
  "launch.startWaitsRepository": "Disponível quando o repositório terminar de ser clonado.",
  "launch.startWaitsPlanning": "Disponível quando o planejamento terminar.",
  "launch.startNeedsRole": "Iniciar os agentes exige o papel de mantenedor neste projeto.",
  "launch.agentsStarted": "Agentes iniciados.",
  "launch.publish": "Publicação",
  "launch.publishButton": "Publicar no Coolify",
  "launch.republish": "Publicar de novo",
  "launch.publishRequested": "Publicação iniciada.",
  "launch.publishBeforeDone": "Nem todas as tarefas estão concluídas: publicar agora coloca no ar o que está na main hoje.",
  "launch.publishNeedsAdmin": "Um administrador da organização publica o app.",
  "launch.publishNone": "Não publicado",
  "launch.publishProgress": "Etapas da publicação",
  "launch.publishFailed": "A publicação falhou.",
  "launch.publishFinished": "Concluída {when}.",
  "launch.openApp": "Abrir o app",
  "launch.publishState.queued": "Na fila",
  "launch.publishState.creating_repository": "Criando o repositório no GitHub",
  "launch.publishState.pushing": "Enviando ao GitHub",
  "launch.publishState.creating_app": "Criando o app",
  "launch.publishState.deploying": "Implantando",
  "launch.publishState.succeeded": "No ar",
  "launch.publishState.failed": "Falhou",

  "publication.notPublished": "Não publicado",
  "publication.publishing": "Publicando… ({state})",
  "publication.live": "No ar",
  "publication.failed": "A publicação falhou",
  "publication.failedCode": "A publicação falhou ({code})",
  "publication.openApp": "Abrir o app",
  "publication.publish": "Publicar",
  "publication.previewHint": "Publique o projeto para obter uma URL no ar",
  "publication.connectGithub": "Conectar o GitHub",
  "publication.emptyTitle": "Ainda não publicado",
  "publication.emptyBody": "Este projeto ainda não tem pré-visualização. Publique-o no Coolify para obter uma URL no ar; o app publicado passa a ser a pré-visualização do projeto.",
  "publication.liveTitle": "App publicado",
  "publication.liveBody": "O projeto está no ar nesta URL. Ela abre em uma nova aba.",
  "publication.policy": "App publicado: o enquadramento nunca foi verificado, por isso ele abre em uma nova aba em vez de ser exibido aqui.",

  "agentRuns.title": "Execuções de agentes",
  "agentRuns.hint": "Todas as execuções de agentes deste projeto. Consultas e delegações aparecem sob a execução que as pediu.",
  "agentRuns.outcomeFilter": "Situação",
  "agentRuns.emptyTitle": "Nenhuma execução de agente ainda",
  "agentRuns.emptyBody": "As execuções aparecem aqui quando os agentes começam a trabalhar nas tarefas deste projeto.",
  "agentRuns.agent": "Agente",
  "agentRuns.purposeColumn": "Finalidade",
  "agentRuns.parent": "Execução de origem",
  "agentRuns.status": "Situação",
  "agentRuns.steps": "Passos",
  "agentRuns.modelCalls": "Chamadas ao modelo",
  "agentRuns.toolCalls": "Chamadas de ferramenta",
  "agentRuns.tokens": "Tokens",
  "agentRuns.tokensDetail": "{input} de entrada, {output} de saída",
  "agentRuns.cost": "Custo",
  "agentRuns.unknownCost": "desconhecido",
  "agentRuns.started": "Início",
  "agentRuns.finished": "Fim",
  "agentRuns.notFinished": "em andamento",
  "agentRuns.limited": "Mostrando as {n} execuções mais recentes.",
  "agentRuns.purpose.build": "Execução",
  "agentRuns.purpose.consult": "Consulta",
  "agentRuns.purpose.delegate": "Delegação",
  "agentRuns.purpose.review": "Revisão",
  "agentRuns.purpose.reflect": "Reflexão",
  "agentRuns.purpose.assistant": "Assistente",
  "agentRuns.outcome.running": "Em andamento",
  "agentRuns.outcome.succeeded": "Concluída",
  "agentRuns.outcome.failed": "Falhou",
  "agentRuns.outcome.interrupted": "Interrompida",
  "agentRuns.outcome.blocked": "Bloqueada",
  "agentRuns.outcome.cancelled": "Cancelada",
};
